import Img from 'react-cool-img';
import styled from 'styled-components';

export const Image = styled(Img).attrs(({ placeholder }) => ({
  cache: true,
  error: placeholder,
  debounce: 1000,
  placeholder,
}))``;
